module.exports = __webpack_public_path__ + "img/list.4ae50c28.svg";